import { ObjectMap } from '@ringcentral-integration/core/lib/ObjectMap';

export const proxyActionTypes = ObjectMap.fromKeys([
  'proxyInit',
  'proxyInitSuccess',
]);

export default proxyActionTypes;
